import React, { useEffect, useState } from "react";
import congrats from "../../Assets/svg/congrats.svg";
import "./fare.scss";
import RedirectHelp from "../modules/RedirectHelp";
import { useSelector } from "react-redux";
function DropoutFarewell() {
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  return (
    <div className="form-div fare-page submitted-welcome">
      {/* <div className="form-title">Welcome back, Mandar!</div> */}

      <div className="content congrats content-item">
        {/* <div className="content-left "> */}
        <div className="congrats-icon">
          <img src={congrats} alt="congrats" />
        </div>
        <div className="congrats-texts">
          <div className="form-title">
            Hello {personalInfo?.firstName}! We wouldn’t like to see you go :(
          </div>
          <div className="set-title">
            <span>Your dropout request has been submitted successfully.</span>
            <span>
              Once IDFC FIRST bank receives the scholarship amount from your college,
              your request will be completed
            </span>
            <span>
              You will receive an update about this on your registered email
              {personalInfo?.email}
            </span>
          </div>
        </div>
      </div>
     <RedirectHelp/>

  
    </div>
  );
}

export default DropoutFarewell;
